import React from 'react';
import PropTypes from 'prop-types';

export const Avatar = ({ src, alt, width, height }) => {
  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = '/assets/img/app/no-avatar.jpg';
  };

  return (
    <figure
      style={{
        width,
        height,
        margin: 0,
        maxWidth: width,
        minWidth: width,
        maxHeight: height,
        minHeight: height,
        overflow: 'hidden',
        borderRadius: '50%'
      }}
    >
      <img src={src} alt={alt} onError={handleImageError} style={{ width, height, objectFit: 'cover' }} />
    </figure>
  );
};

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
};

Avatar.defaultProps = {
  src: '/assets/img/app/no-avatar.jpg',
  alt: 'profile image',
  width: '42px',
  height: '42px'
};
